import { stopSubmit } from 'redux-form';

import {
  USER_LOADING,
  USER_LOADED,
  AUTH_ERROR,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT_SUCCESS
} from './types';

export const loadUser = (data) => async (dispatch, getState) => {
  dispatch({ type: USER_LOADING });
  try {
    fetch('https://sinomost.kz/API/auth/user/', {
      headers: {
        'Authorization': `Token ${getState().auth.token}`
      }
    })
    .then(res => res.json())
    .then(data => dispatch({
      type: USER_LOADED,
      payload: data
    }));
  } catch (err) {
    dispatch({
      type: AUTH_ERROR
    });
  }
};


export const login = ({ username, password } ) => async dispatch => {
  try {
    fetch('https://sinomost.kz/API/auth/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, password })
    })
    .then(res => res.json())
    .then(user => dispatch({
      type: LOGIN_SUCCESS,
      payload: user
    }));
  } catch (err) {
    dispatch({
      type: LOGIN_FAIL
    });
    dispatch(stopSubmit('loginForm', err.response.data));
  }
};

// LOGOUT USER
export const logout = () => async (dispatch, getState) => {
  fetch('https://sinomost.kz/API/auth/logout', {
    method: 'POST',
    headers: {
      'Authorization': `Token ${getState().auth.token}`
    }
  })
  .then(res => res.json())
  .then(data => dispatch({
    type: LOGOUT_SUCCESS
  }));
};

// REGISTER USER
export const register = ({ username, email, password }) => async dispatch => {
  try {
    fetch('https://sinomost.kz/API/auth/register', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ username, email, password })
    })
    .then(res => res.json())
    .then(user => dispatch({
      type: REGISTER_SUCCESS,
      payload: user
    }));
  } catch (err) {
    dispatch({
      type: REGISTER_FAIL
    });
    dispatch(stopSubmit('registerForm', err.response.data));
  }
};